import styled from 'styled-components';
import color from 'tinycolor2';
import { Link as ReactLink } from 'react-router-dom';

export const PageNav = styled.nav`
  padding: 15px 12px;
`;

export const PageNavLink = styled(ReactLink)`
  text-decoration: none;
`;

export const PageNavIconRight = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme['color.text.light']};
`;

export const PageNavItem = styled.div`
  display: flex;
  width: 100%;
  height: 38px;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px 0 11px;
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.theme['color.text.body']};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0;
  text-transform: capitalize;
  border-radius: 4px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    outline: none;
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.05).toString()};
  }

  ${(props) => !(props.disabled || props.active) && `
    cursor: pointer;
  `}

  ${(props) => props.disabled && `
    opacity: 0.2;
    font-weight: normal;

    &:hover {
      background: none;
    }
  `}

  ${(props) => props.active && `
    color: ${props.theme['color.primary.text']};

    &:hover {
      background: none;
    }
  `}
`;
